import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "vuetify/lib/locale/en";
import ru from "vuetify/lib/locale/ru";

Vue.use(VueI18n);

const messages = {
  ru: {
    ...require("@/locales/ru.json"),
    $vuetify: ru,
  },
  en: {
    ...require("@/locales/en.json"),
    $vuetify: ru,
  },
};

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "ru",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages,
});

export default i18n;
